<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Solução</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-group-solution-by-city-combobox
              :filter="municipioGrupoSolucao"
              :onlyEnable="true"
              v-if="
                !filter.municipioGrupoSolucao ||
                !filter.municipioGrupoSolucao.municipioGrupoSolucaoId
              "
            ></app-group-solution-by-city-combobox>

            <v-text-field
              v-model="filter.municipioGrupoSolucao.nome"
              v-if="
                filter.municipioGrupoSolucao &&
                filter.municipioGrupoSolucao.municipioGrupoSolucaoId
              "
              label="Grupo de Solução"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-consultant-combobox
              :filter="payload"
            ></app-consultant-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-radio-group v-model="payload.monitoramento">
              <v-radio
                v-for="monitoramento in tiposMonitoramento"
                :label="monitoramento.label"
                :value="monitoramento.value"
                :key="monitoramento.value"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataInicioString"
              v-mask="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataTerminoString"
              v-mask="'##/##/####'"
              label="Data de Término"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de visitas presenciais"
              name="numero-visitas-presenciais"
              type="number"
              required
              v-model="payload.visitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de visitas presenciais"
              name="horas-previstas-visitas-presenciais"
              type="number"
              required
              v-model="payload.horasPrevistasVisitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de trabalhos de escritório"
              name="numero-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.trabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de trabalhos de escritório"
              name="horas-previstas-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.horasPrevistasTrabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox
              v-model="payload.naoComputaHoras"
              label="Não Computa Horas?"
              color="primary"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { citySolutionAPI } from "@/modules/city/API/CitySolutionAPI";
import { AppGroupSolutionByCityCombobox } from "@/modules/axis";
import { AppConsultantCombobox } from "@/modules/user";
import { mapActions } from "vuex";

export default {
  name: "AppModalInsertSolution",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: { type: Object, required: false },
    municipioSolucao: {},
    allSolutions: [],
  },
  components: {
    AppGroupSolutionByCityCombobox,
    AppConsultantCombobox,
  },
  data() {
    return {
      payload: {
        monitoramento: 1,
        municipioId: this.$route.params.id,
        municipioGrupoSolucao: {},
      },
      municipioGrupoSolucao: {
        municipioGrupoSolucao: {},
      },
      dialog: false,
      tiposMonitoramento: [
        { label: "Tarefas", value: 1 },
        { label: "Visitas", value: 2 },
      ],
    };
  },
  mounted() {
    if (this.object && this.edit === true) {
      this.payload = { ...this.object };
      this.municipioGrupoSolucao.municipioGrupoSolucao = {
        ...this.object.municipioGrupoSolucao,
      };
    } else {
      this.municipioGrupoSolucao.municipioGrupoSolucao =
        this.filter.municipioGrupoSolucao;
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    close() {
      if (this.edit !== true) {
        this.payload = {
          monitoramento: 1,
          municipioId: this.$route.params.id,
          municipioGrupoSolucao: this.municipioGrupoSolucao,
        };
      } else {
        this.payload = { ...this.object };
        this.municipioGrupoSolucao.municipioGrupoSolucao =
          this.object.municipioGrupoSolucao;
      }
      this.dialog = false;
    },
    onConfirm() {
      if (
        !this.municipioGrupoSolucao.municipioGrupoSolucao
          .municipioGrupoSolucaoId
      ) {
        this.$notification.error(
          "O preenchimento de um grupo de solução é obrigatório."
        );
      } else {
        this.setLoading(true);

        const valores = {
          ...this.payload,
          municipioGrupoSolucaoId:
            this.municipioGrupoSolucao.municipioGrupoSolucao
              .municipioGrupoSolucaoId,
          municipioGrupoSolucao: null,
        };

        if (this.edit === true) {
          citySolutionAPI
            .update(valores)
            .then(() => {
              this.dialog = false;
              this.setLoading(false);
              this.payload = { ...this.object };

              this.$emit("onSave");
            })
            .catch((resp) => {
              this.setLoading(false);
              console.log("Erro ao editar solução ", resp);

              this.$notification.error("Erro ao atualizar solução");
            });
        } else {
          citySolutionAPI
            .create(valores)
            .then(() => {
              this.dialog = false;
              this.setLoading(false);
              this.payload = {
                monitoramento: 1,
                municipioId: this.$route.params.id,
                municipioGrupoSolucao: this.municipioGrupoSolucao,
              };

              this.$emit("onSave");
            })
            .catch((resp) => {
              this.setLoading(false);
              console.log("Erro ao criar solução ", resp);
              this.$notification.error("Erro ao criar solução");
            });
        }
      }
    },
  },
  watch: {
    "filter.municipioGrupoSolucao"(newValue) {
      if (this.filter.municipioGrupoSolucao) {
        this.municipioGrupoSolucao.municipioGrupoSolucao = newValue;
      }
    },
    object(newValue) {
      this.payload = newValue;
    },
  },
};
</script>
